import React from 'react';

export const JobApplication = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="
http://www.w3.org/2000/svg"
  >
    <path
      d="M18 22H6C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19584 21.0208 4 20.55 4 20V4C4 3.45 4.19584 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22ZM6 20H18V4H6V20Z"
      fill="#444D55"
    />
    <path
      d="M13.4125 12.4125C13.0208 12.8042 12.55 13 12 13C11.45 13 10.9792 12.8042 10.5875 12.4125C10.1958 12.0208 10 11.55 10 11C10 10.45 10.1958 9.97917 10.5875 9.5875C10.9792 9.19583 11.45 9 12 9C12.55 9 13.0208 9.19583 13.4125 9.5875C13.8042 9.97917 14 10.45 14 11C14 11.55 13.8042 12.0208 13.4125 12.4125Z"
      fill="#444D55"
    />
    <path
      d="M16 17H8V16.425C8 16.025 8.10834 15.6583 8.325 15.325C8.54167 14.9917 8.84167 14.7417 9.225 14.575C9.65834 14.3917 10.1042 14.25 10.5625 14.15C11.0208 14.05 11.5 14 12 14C12.5 14 12.9792 14.05 13.4375 14.15C13.8958 14.25 14.3417 14.3917 14.775 14.575C15.1583 14.7417 15.4583 14.9917 15.675 15.325C15.8917 15.6583 16 16.025 16 16.425V17Z"
      fill="#444D55"
    />
    <path
      d="M2.7125 19.7125C2.90417 19.5208 3 19.2833 3 19V5C3 4.71667 2.90417 4.47917 2.7125 4.2875C2.52083 4.09583 2.28333 4 2 4C1.71667 4 1.47917 4.09583 1.2875 4.2875C1.09583 4.47917 1 4.71667 1 5L1 19C1 19.2833 1.09583 19.5208 1.2875 19.7125C1.47917 19.9042 1.71667 20 2 20C2.28333 20 2.52083 19.9042 2.7125 19.7125Z"
      fill="#444D55"
    />
    <path
      d="M22.7125 19.7125C22.9042 19.5208 23 19.2833 23 19V5C23 4.71667 22.9042 4.47917 22.7125 4.2875C22.5208 4.09583 22.2833 4 22 4C21.7167 4 21.4792 4.09583 21.2875 4.2875C21.0958 4.47917 21 4.71667 21 5V19C21 19.2833 21.0958 19.5208 21.2875 19.7125C21.4792 19.9042 21.7167 20 22 20C22.2833 20 22.5208 19.9042 22.7125 19.7125Z"
      fill="#444D55"
    />
  </svg>
);
